import React from 'react'
import { withStyles } from '@mui/styles'

import { SCROLLBAR } from "../../modules/constants"

import Box from "@mui/material/Box"
import Scrollbars from "react-custom-scrollbars-2"


const styles = theme => ({
  landscape: {
    flex: "1",
    display: "flex",
    flexFlow: "row",

    minHeight: 0, // prevents div height getting bigger than available vertical space
  },
  portrait: {
    flex: "1",
    display: "flex",
    flexFlow: "column",

    overflowX: "hidden", // don't allow horizontal scrolling
    overflowY: "auto", // allow vertical scrolling (default?)
  }
})

const MainSection = ({ classes, children, portrait, style }) =>
  <Box
    id="main-section"
    className={portrait ? classes.portrait : classes.landscape}
    style={style}
  >
    {portrait && <Scrollbars autoHide
      autoHideTimeout={SCROLLBAR.AH_TIMEOUT}
      autoHideDuration={SCROLLBAR.AH_DURATION}>
      {children}
    </Scrollbars>}

    {!portrait && children}
  </Box>

export default withStyles(styles)(MainSection)